import React from "react";
import "./ourteam.css";
import { FaLinkedin, FaTwitter, FaInstagram } from "react-icons/fa";

const teamMembers = [
  {
    name: "Rajat Mehta",
    role: "Founder & CEO",
    image: "https://images.unsplash.com/photo-1603415526960-f7e0328c63b1?auto=format&fit=crop&w=600&q=60",
    linkedin: "#",
    twitter: "#",
    instagram: "#",
  },
  {
    name: "Surender Sharma",
  role: "Marketing Head",
  image: "https://images.unsplash.com/photo-1595152772835-219674b2a8a6?auto=format&fit=crop&w=600&q=80",
  linkedin: "#",
  twitter: "#",
  instagram: "#",
  },
  {
    name: "Aman Gupta",
    role: "Tech Lead",
    image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&w=600&q=60",
    linkedin: "#",
    twitter: "#",
    instagram: "#",
  },
  {
    name: "Sneha Verma",
    role: "UI/UX Designer",
    image: "https://images.unsplash.com/photo-1619946794135-5bc917a27793?auto=format&fit=crop&w=600&q=60",
    linkedin: "#",
    twitter: "#",
    instagram: "#",
  },
];

const OurTeam = () => {
  return (
    <section className="team-section">
      <div className="team-container">
        <h2 className="team-title">Meet Our Team</h2>
        <p className="team-subtitle">
          Passionate professionals driving innovation and excellence every day.
        </p>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-card">
              <div className="team-image">
                <img src={member.image} alt={member.name} />
                <div className="team-overlay">
                  <div className="social-icons">
                    <a href={member.linkedin}>
                      <FaLinkedin />
                    </a>
                    <a href={member.twitter}>
                      <FaTwitter />
                    </a>
                    <a href={member.instagram}>
                      <FaInstagram />
                    </a>
                  </div>
                </div>
              </div>
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
